/*
 *
 * Virtual Market
 * user-api - Servicios
 *
 * SEKAISOFT 2020
 *
 */

/* Core Imports */
import axios from 'axios';
import { API_URL } from './config';

/* Dev Tools */
import { DEBUG } from 'common-protocols';
const OBJECT_ID = 'User-api';

/*********************** Obtener Token User ***********************/
export function getTokenUser(data) {
    DEBUG && console.log(OBJECT_ID + "@getTokenUser: Petición del token Admin");

    let requestUrl = `${API_URL}/login`;
    DEBUG && console.log(OBJECT_ID  + "@getTokenUser: requestUrl --> " + requestUrl);

    const body = {
        userName: data.username,
        password: data.password
    }

    let request = {
        url: requestUrl,
        method: "post",
        data: body
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function requestRecoverUser(username) {
    DEBUG && console.log(OBJECT_ID + "@requestRecoverUser: Petición de recuperar usuario");

    let requestUrl = `${API_URL}/forgotPassword`;
    DEBUG && console.log(OBJECT_ID  + "@requestRecoverUser: requestUrl --> " + requestUrl);

    const body = {
        userName: username
    }

    let request = {
        url: requestUrl,
        method: "post",
        data: body
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function requestValidToken(action) {
    DEBUG && console.log(OBJECT_ID + "@requestValidToken: Validar Token");

    let requestUrl = `${API_URL}/token`;
    DEBUG && console.log(OBJECT_ID  + "@requestValidToken: requestUrl --> " + requestUrl);


    let request = {
        url: requestUrl,
        method: "post",
        headers: {'X-AUTH-TOKEN': action.token},
        data: action.rol,
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function changePassword({password, confirmPassword, token}) {
    DEBUG && console.log(OBJECT_ID + "@changePassword: Cambiar Contraseña");

    let requestUrl = `${API_URL}/usuario`;
    DEBUG && console.log(OBJECT_ID  + "@changePassword: requestUrl --> " + requestUrl);


    let request = {
        url: requestUrl,
        method: "patch",
        headers: {'X-AUTH-TOKEN': token},
        data: {
            password,
            confirmPassword
        },
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}

export function requestConfirmationEmail(email) {
    DEBUG && console.log(OBJECT_ID + "@requestConfirmationEmail: Reenviar correo confirmación");

    let requestUrl = `${API_URL}/email/confirm`;
    DEBUG && console.log(OBJECT_ID  + "@requestConfirmationEmail: requestUrl --> " + requestUrl);

    let request = {
        url: requestUrl,
        method: "post",
        data: {
            email
        },
    };

    return axios(request)
        .then(response=> ({ response }))
        .catch(error => ({ error }))
}


// WEBPACK FOOTER //
// ./src/services/user-api.js